<template>
  <div class="-mt-4">
    <DraftMain
      :panelTitle="panelTitle"
      :initialValues="initialValues"
      :onSearch="onSearch"
      :containerClass="'!my-0'"
    >
      <template #searchHeadOperation> </template>
      <template #searchOperation="{ resetForm }">
        <div class="flex gap-2">
          <FilledButton
            class="px-5 py-1.5 text-white flex gap-2 items-center"
            fillClass="bg-gray-400"
            @click.prevent="resetForm"
          >
            <i class="fa fa-trash text-white"></i>
            {{ $t('clear') }}
          </FilledButton>
          <FilledButton class="px-5 py-1.5 text-white">
            <i class="fa fa-search text-white"></i>
            {{ $t('search') }}
          </FilledButton>
        </div>
      </template>
      <template #searchPanel="{ values }">
        <FreeZoneSearchPanel
          :initialValues="initialValues"
          :panelType="panelType"
          :values="values"
        />
      </template>
      <template #searchResult>
        <DraftTable
          :isLoading="isLoading"
          :tableData="tableData"
          :initialValues="initialValues"
          :pageLength="pageLength"
          @onPageClick="onPageClick"
          @selected="selectedNumberOfRow"
          @checked="selectedRow"
          @checkOut="checkOut"
          @checkIn="checkIn"
          @delete="deleteSelected"
        />
      </template>
    </DraftMain>
  </div>
</template>
<script setup>
import { onBeforeMount, ref } from 'vue'
import { notify } from 'notiwind'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import FilledButton from '@/components/Buttons/Filled.vue'
import DraftMain from '@/views/individual/draft/Main.vue'
import DraftTable from '@/views/individual/draft/DraftTable.vue'
import FreeZoneSearchPanel from '@/views/establishment/childEstablishment/SearchPanel/FreeZoneSearch.vue'
import apiHelperService from '@/services'
import lookups from '@/assets/json/clientLookups.json'

const route = useRoute()
const router = useRouter()
const i18n = useI18n()

const draftId = ref([])
const panelTitle = ref('canceledChildEstablishments')
const isLoading = ref(false)
const requireEnrollmentInd = ref(false)
const initialValues = ref({
  currentPage: 1,
  pageSize: 10
})

const pageLength = ref(10)
const tableData = ref([])
const draftStatusId = ref('')

const requestTableData = async (value) => {
  isLoading.value = true
  const payload = {
    currentPage: initialValues.value.currentPage,
    pageSize: pageLength.value,
    ...value,
    data: {
      ...value
    }
  }
  router.replace({ query: value })
  try {
    const response = await apiHelperService.post(
      '/api/establishment/freeZone/searchEstablishmentChilds',
      payload
    )
    if (response) {
      if (requireEnrollmentInd.value === true) {
        draftStatusId.value = lookups.draftStatus.waitingFoFingerprint
      }
      isLoading.value = false
      return response
    }
  } catch (error) {
    console.error('requestTableData', error)
  }
}

const selectedNumberOfRow = async (num) => {
  pageLength.value = num
  initialValues.value = {
    ...initialValues.value,
    pageSize: +pageLength.value,
    currentPage: 1
  }
  tableData.value = await requestTableData(initialValues.value)
}

const onPageClick = async (pageNum) => {
  initialValues.value = {
    ...initialValues.value,
    currentPage: +pageNum
  }
  tableData.value = await requestTableData(initialValues.value)
}

const onSearch = async (value) => {
  tableData.value = await requestTableData(value)
}

const selectedRow = (draft) => {
  if (!draft) return
  draftId.value = draft
}

const deleteSelected = (draft) => {
  draftId.value = draft
}

const checkOut = async () => {
  tableData.value = await requestTableData(initialValues.value)
  notify(
    {
      group: 'success',
      title: i18n.t('Success'),
      text: i18n.t('checkedOutSuccessfully')
    },
    6000
  )
}

const checkIn = async () => {
  tableData.value = await requestTableData(initialValues.value)
  notify(
    {
      group: 'success',
      title: i18n.t('Success'),
      text: i18n.t('checkedInSuccessfully')
    },
    6000
  )
}

const setDraftResponse = async () => {
  tableData.value = await requestTableData(initialValues.value)
}

const renderPage = () => {
  if (route.fullPath.indexOf('CanceledChildEstablishments') >= 0) {
    panelTitle.value = 'canceledChildEstablishments'
  } else {
    panelTitle.value = 'searchFreeZoneChildEstablishments'
  }
}

onBeforeMount(async () => {
  renderPage()
  await setDraftResponse()
  const searchParams = route.query
  initialValues.value = searchParams
})
</script>
<style></style>
